import {updateTeamMember} from '@/api/team';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import type {UpdateTeamMemberRequest} from '@/types/api';

export function useUpdateTeamMember() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({id, data}: { id: string; data: UpdateTeamMemberRequest }) => updateTeamMember(id, data),
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({queryKey: ['teamMembers']});
            queryClient.invalidateQueries({queryKey: ['teamMember', variables.id]});
        }
    });
}
